import { render } from "./leave-balances.vue?vue&type=template&id=453e7710&scoped=true"
import script from "./leave-balances.vue?vue&type=script&lang=js"
export * from "./leave-balances.vue?vue&type=script&lang=js"

import "./leave-balances.vue?vue&type=style&index=0&id=453e7710&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453e7710"]])

export default __exports__